"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _preactCompat = require("preact-compat");

var _ImageLightbox = require("@insided/shared/components/ImageLightbox");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'common-content';
exports.cssAnchorName = cssAnchorName;

var Content = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Content, _PureComponent);

  var _super = _createSuper(Content);

  function Content() {
    var _this;

    (0, _classCallCheck2.default)(this, Content);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "element", null);
    return _this;
  }

  (0, _createClass2.default)(Content, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderSubComponents();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderSubComponents();
    }
  }, {
    key: "renderSubComponents",
    value: function renderSubComponents() {
      if (this.element) {
        window.insided.bindPreactComponents(this.element); // Bind modern Preact lightbox to images in this content

        _ImageLightbox.ImageLightbox.bindTo(this.element);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          content = _this$props.content,
          className = _this$props.className,
          isControl = _this$props.isControl;
      return (0, _preact.h)("div", {
        ref: function ref(element) {
          _this2.element = element;
        },
        className: (0, _classnames.default)(className, 'post__content', 'post__content--new-editor', {
          'post__content--control': isControl
        }),
        dangerouslySetInnerHTML: {
          __html: content
        }
      });
    }
  }]);
  return Content;
}(_preactCompat.PureComponent);

var _default = Content;
exports.default = _default;